import PracticeMembersAPI from 'api/PracticeMembersAPI'
import UsersAPI from 'api/UsersAPI'
import Store from '@/store'
import PracticesAPI from 'api/PracticesAPI'

export function buildPracticeStoreUpdates(formData, apiPractice = {}) {
    const updates = { ...apiPractice }

    if (formData.name !== undefined) {
        updates.name = formData.name
    }
    if (formData.email !== undefined) {
        updates.email = formData.email
    }
    if (formData.phone !== undefined) {
        updates.phone = formData.phone
    }
    if (formData.mobilePhone !== undefined) {
        updates.mobilePhone = formData.mobilePhone
    }
    if (formData.isAgreedToSms !== undefined) {
        updates.isAgreedToSms = formData.isAgreedToSms
    }
    if (formData.faxNumber !== undefined) {
        updates.fax = formData.faxNumber
    }
    if (formData.fax !== undefined) {
        updates.fax = formData.fax
    }

    return updates
}

export function applyPracticeUpdateToStore(updates) {
    if (!updates || typeof updates !== 'object') {
        return
    }

    const practice = Store.getters['auth/getPractice']
    Store.dispatch('auth/setPractice', { ...practice, ...updates })

    if (!updates.name) {
        return
    }

    const members = Store.getters['auth/getMembers']
    if (!members.length) {
        return
    }

    Store.dispatch(
        'auth/setMembers',
        members.map((member) => (member.practice ? { ...member, practice: { ...member.practice, name: updates.name } } : member)),
    )
}

export function applyUserUpdateToStore(userId, updates) {
    if (!updates) {
        return
    }

    const id = parseInt(userId)
    const user = Store.getters['auth/getUser']

    if (parseInt(user.id) === id) {
        Store.dispatch('auth/setUser', { ...user, ...updates })
    }

    const members = Store.getters['auth/getMembers']
    if (members.length) {
        Store.dispatch(
            'auth/setMembers',
            members.map((member) => (parseInt(member.id) === id ? { ...member, ...updates } : member)),
        )
    }
}

export function updateStoreMembers(input) {
    const practiceId = Store.getters['auth/getPractice']?.id || Store.getters['auth/getUser']?.practiceId
    return PracticeMembersAPI.getList(practiceId, { limit: 50, offset: 0 })
        .then((members) => Store.dispatch('auth/setMembers', members))
        .then(() => input)
        .catch(() => Promise.resolve(input))
}

export function updateCurrentUser() {
    return UsersAPI.getCurrent().then((user) => Store.dispatch('auth/setUser', user))
}

export function updateCurrentPractice() {
    return PracticesAPI.getMy().then((practice) => {
        Store.dispatch('auth/setPractice', practice)
    })
}

function toEmailList(value) {
    return [].concat(value || []).filter(Boolean)
}

export function buildMailtoUrl({ to, cc, bcc, subject, body }) {
    const toList = toEmailList(to)
    if (!toList.length) {
        return null
    }

    const params = []
    const ccList = toEmailList(cc)
    const bccList = toEmailList(bcc)

    if (ccList.length) {
        params.push(`cc=${ccList.map(encodeURIComponent).join(',')}`)
    }
    if (bccList.length) {
        params.push(`bcc=${bccList.map(encodeURIComponent).join(',')}`)
    }
    if (subject) {
        params.push(`subject=${encodeURIComponent(subject)}`)
    }
    if (body) {
        params.push(`body=${encodeURIComponent(body)}`)
    }

    const query = params.length ? `?${params.join('&')}` : ''
    return `mailto:${toList.map(encodeURIComponent).join(',')}${query}`
}

export function openMailtoUrl(url) {
    if (!url) {
        return false
    }

    const link = document.createElement('a')
    link.href = url
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true
}

export function openEmailClient({ to, cc, bcc, subject, message }) {
    const toList = toEmailList(to)
    if (!toList.length) {
        return false
    }

    const primaryRecipient = toList[0]
    const additionalBcc = toList.slice(1)
    const allBcc = [...additionalBcc, ...toEmailList(bcc)]

    return openMailtoUrl(
        buildMailtoUrl({
            to: primaryRecipient,
            cc,
            bcc: allBcc,
            subject,
            body: message,
        }),
    )
}
